import React from "react";
// 公共组件
import { Row, Col } from "../CtGrid";

// 业务组件
import CtMedia from "../CtMedia";
import "./css/index.scss";
// console.log(Row);

export default function MdComplex(props) {
  const { data } = props;
  return (
    <div className='material-mdComplex'>
      {/* <div className='material-mdComplex__content'>
        <div className='material-mdComplex__content-img'>
          <img src={data.content.img} alt='' />
        </div>
        <div className='material-mdComplex__content-info'>
          {data.content.title && (
            <div className='material-mdComplex__content-info--title'>
              {data.content.title}
            </div>
          )}
          {data.content.desc && (
            <div className='material-mdComplex__content-info--desc'>
              {data.content.desc}
            </div>
          )}
          {data.content.link && (
            <div className='material-mdComplex__content-info--link'>
              {data.content.link}
            </div>
          )}
        </div>
      </div> */}
      <div className='material-mdComplex__case'>
        <Row gutter={[20, 20]}>
          {data.media.map((item, index) => (
            <Col colSpan={8} phone={24} key={`col-${index}`}>
              <CtMedia data={item} card shadow radius horizon />
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}
